<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.mobile"
    v-model="dialog"
    persistent
    :max-width="576"
  >
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary"> <v-icon left>add</v-icon>{{titleBtn}}</v-btn>
    </template>
    <v-card>
      <v-toolbar color="#FFB300" dense class="elevation-0" dark>
        <v-toolbar-title>Tạo mới khoản thu</v-toolbar-title>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-5">
        <production-new-form ref="form" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn style="width: 96px" text color="primary" @click="cancel"
            >Hủy</v-btn
          >
          <v-btn style="width: 96px" color="primary" @click="save">Lưu</v-btn>
        </v-card-actions></v-card-text
      >
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import ProductionNewForm from '@/components/basic/form/ProductionNewForm.vue'

export default {
  components: { ProductionNewForm },
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapActions('product', ['fetchProducts']),
    ...mapActions('product', ['createProduct', 'fetchProducts']),
    async save() {
      const data = this.$refs.form.getData()
      await this.createProduct({
        data: {
          ...data,
          status: 'active',
          department: this.department.id,
        },
      })
      this.dialog = false
      this.reset()
    },

    cancel() {
      this.reset()
      this.$emit('cancel')
      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    },
  },
  created() {
    this.fetchProducts()
  },
  computed: {
    ...mapGetters('product', ['products']),
    ...mapGetters('app', ['department']),
    titleBtn() {
      switch (this.$vuetify.breakpoint.name) {
      case 'xs':
      case 'sm':
        return 'Thêm'
      default:
        return 'Thêm Khoản Thu'
      }
    },
  },
}
</script>
<style scoped>
</style>
